
  import {defineComponent} from "vue";

  export default defineComponent({
    name: 'authentication-prompt-component'
  })
